<template>
  <div class="agent-list">
    <van-sticky>
      <van-nav-bar :border="false">
        <template #title>
          <strong>代理链接列表</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-22 fw-700" @click="$router.back()"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" class="flex-1" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      ><div class="card-list">
          <div v-for="item in list" :key="item.id" class="card-item">
            <div class="item_top flex align-center justify-between">
              <div class="flex">
                <span>代理账号：</span>
                <p>{{ item.phone }}</p>
              </div>
              <van-tag :color="+new Date() > item.expiretime * 1000 ? 'gray' : '#07c160'">{{ +new Date() > item.expiretime * 1000 ? '失效' : '有效'}}</van-tag>
              <div class="btn-wrapper">
                <div class="btn" @click="generate(item)">生成</div>
                <div class="btn" @click="refreshLink(item.id)">恢复</div>
              </div>
            </div>
            <div class="item_bottom flex justify-between">
              <p>代理名称：<span>{{ item.name }}</span></p>
              <p>创建时间：<span>{{ item.createtime * 1000 | formatTime }}</span></p>
            </div>
          </div>
        </div>
        <template v-if="list.length > 0" #finished>
          <span>没有更多了</span>
        </template>
        <van-empty v-if="list.length === 0" description="暂无数据" />
      </van-list>
    </van-pull-refresh>
    <div id="box">
      <vue-qr :text="qrText" :size="250" :margin="5" style="display: none;"></vue-qr>
      <canvas ref="canvas" style="display: none;"></canvas>
    </div>
    <van-dialog v-model="show" title="二维码" show-cancel-button cancelButtonText="关闭" :showConfirmButton="isPlus ? true : false" confirmButtonText="分享" @confirm="share">
      <div class="img-wrapper">
        <img v-if="shareImg" :src="shareImg" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import { refreshLink, getReglist } from '@/api/agent.js'
import { mapState } from 'vuex'
import GenerateImg from './mixin/generate-img.js'
export default {
  name: 'GenerateAgentList',
  mixins: [GenerateImg],
  components: { vueQr },
  data() {
    return {
      loading: false,
      finished: false,
      isLoading: false,
      currentPage: 0, // 当前页码
      qrImg: '', // 二维码图片
      qrText: '', // 用于生成二维码的内容
      shareImg: '', // 要分享的图片
      show: false, // 弹窗
      list: []
    }
  },
  computed: {
    ...mapState(['isPlus'])
  },
  mounted() {
    window.scrollTo(null, 0)
  },
  methods: {
    async getReglist(type) {
      const res = await getReglist({ page: this.currentPage })
      const { data, current_page } = res.data
      this.currentPage = +current_page // 隐士转化为Number类型
      if (type === 'refresh') { // 下拉刷新
        this.list = data
      } else { // 上拉加载
        this.list = [...this.list, ...data]
      }
      return data.length
    },
    async onRefresh() {
      this.currentPage = 1
      await this.getReglist('refresh')
      this.$toast('刷新成功')
      this.isLoading = false
      this.finished = false
    },
    async refreshLink(id) {
      this.$store.commit('TOGGLE_LOADING', true)
      try {
        const res = await refreshLink({ id })
        if (res.code === 1) {
          await this.getReglist('refresh')
          this.$toast(res.msg)
        }
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async onLoad() {
      this.loading = true
      this.currentPage = this.currentPage + 1
      const length = await this.getReglist()
      if (length < 1) {
        this.finished = true
      }
      this.loading = false
    },
    generate(item) {
      this.show = true
      this.qrText = item.url
      localStorage.setItem('generateAgentUsreInfo', JSON.stringify({
        phone: item.phone
      }))
      // 生成二维码
      this.qrImg = document.getElementById('box').querySelector('img')
      this.initCanvas(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.agent-list{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: 100vh;
  }
}
.card-item{
  width: 95vw;
  margin: 10px auto 0;
  border-radius: 10px;
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 3px 5px 0 #c0bdbd;
  .item_top{
    margin-bottom: 10px;
    font-size: 14px;
  }
  .item_bottom{
    font-size: 10px;
    color: #999;
  }
  .btn-wrapper{
    display: flex;
    .btn:not(:last-child){
      margin-right: 15px;
    }
    .btn{
      border-radius: 5px;
      padding: 3px 8px;
      background-color: #169bd5;
      color: #fff;
    }
  }
}
.img-wrapper{
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: center;
  img{
    width: 80%;
  }
}
</style>
